import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';
import { Moment } from 'moment';

export const GetCustomersQuery = gql`
  query(
    $eshopDomain: String!,
    $filterSearch: String,
    $filter: JSON,
    $id: [String],
    $first: Int,
    $skip: Int,
    $orderBy: String,
    ) {
    customersCount(
      where: {
        search: $filterSearch,
        eshop: { domain: $eshopDomain },
        filter: $filter,
        id: $id,
      }
    )
    customers(
      first: $first,
      skip: $skip,
      orderBy: $orderBy,
      where: { 
        search: $filterSearch,
        eshop: { domain: $eshopDomain },
        filter: $filter,
        id: $id,
      }
    ) {
      id
      email
      phone
      createdAt

      receiveNewsletter

      invoiceFirstName
      invoiceLastName
      invoiceStreet
      invoiceHouseNumber
      invoiceAddressLine1
      invoiceAddressLine2
      invoiceZip
      invoiceCity
      invoiceCountyState
      invoiceCountry

      companyInformation
      companyName
      companyVatNumber
      companyRegistrationNumber

      anotherDeliveryAddress
      deliveryStreet
      deliveryHouseNumber
      deliveryAddressLine1
      deliveryAddressLine2
      deliveryZip
      deliveryCity
      deliveryCountyState
      deliveryCountry

      saleTaxCertificate
      inactive
      
      discount

      customerGroup {
        id
        name
      }

      customerGroupIds

      lastLogin
      pohodaCustomerId
      pohodaOrderVolume
      jsonPricesDownloadToken
    }
  }
`;

const UpdateCustomerMutation = gql`
  mutation($id: String!, $customer: UpdateCustomerInput!) {
    updateCustomer(id: $id, customer: $customer) {
      id
    }
  }
`;

const DeleteCustomerMutation = gql`
  mutation delete($id: String!) {
    deleteCustomer(id: $id) {
      id
    }
  }
`;

export interface CustomerFilter {
  query?: string;
  page: number | undefined;
  createdAtFrom: string | null;
  createdAtTo: string | null;
  customerGroup: string[] | null;
  discount: string[] | null;
  vouchersUsedFrom: string | null;
  vouchersUsedTo: string | null;
  discountFrom: string | null;
  discountTo: string | null;
  orderCountFrom: string | null;
  orderCountTo: string | null;
  currencies: string[] | null;
  grandTotalFrom: string | null;
  grandTotalTo: string | null;
  lastOrderDateFrom: string | null;
  lastOrderDateTo: string | null;
  receiveNewsletter: string[] | null;
  lastLoginFrom: string | null;
  lastLoginTo: string | null;
  pohodaCustomerId?: string[] | null;  
}

interface IInputProps {
  children?: any;
  filter: CustomerFilter;
  limit?: number;
  skip?: number;
  orderBy?: string;
  domain: string;
  customerId?: string | string[];
}

interface Response {
  data: any;
}

class CustomersQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  public render() {
    const { customers, updateCustomer, deleteCustomer, 
    }: any = this.props;
    return this.props.children({
      customers,
      updateCustomer,
      deleteCustomer,
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(GetCustomersQuery, {
    name: 'customers',
    options: props => ({
      variables: {
        filterSearch: props.filter && props.filter.query || '',
        eshopDomain: props.domain ? props.domain : '',
        customerId: props.customerId,
        filter: props.filter,
        id: Array.isArray(props.customerId) && props.customerId || ('string' === typeof props.customerId) && [props.customerId] || undefined,
        first: props.limit,
        skip: props.skip,
        orderBy: props.orderBy,
      },
      fetchPolicy: 'network-only'
    })
  }),
  graphql<IInputProps, Response>(UpdateCustomerMutation, {
    name: 'updateCustomer'
  }),
  graphql<IInputProps, Response>(DeleteCustomerMutation, {
    name: 'deleteCustomer'
  }),
)(CustomersQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Customers/Customers.tsx